<template>
  <div>
    <div class="row">
      <!-- v-if="!openDay" -->

      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'informes' }">{{
                $t("informes")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("sageasientos") }}
            </li>
          </ol>
        </nav>
      </div>

      <!-- CABECERA DE BUSQUEDA POR NEGOCIO, TPV, FECHA INICIO, FECHA FIN (IGUAL QUE LA DE VENTASNEGOCIOS)  -->
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="getTpv(), (idsTPV = [])"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="listTPV">{{ $t("TPV") }}</label>

                <div class="row">
                  <div class="col-12">
                    <el-select
                      class="select-default"
                      size="large"
                      v-model="idTpv"
                      filterable
                      @change="changeTPV()"
                      :placeholder="$t('seleccionaTpv')"
                    >
                      <el-option
                        v-for="tpv in listTpv"
                        class="select-primary"
                        :value="tpv.id"
                        :label="tpv.nameShow"
                        :key="tpv.id"
                      >
                      </el-option>
                    </el-select>
                  </div>

                </div>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: 'Aceptar', cancel: 'Salir' }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
              <!--<div v-if="busquedaPorHoras" class="form-group">
                                <label>{{$t("horaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        type="time"
                                        :title="$t('horarioInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        format="HH:mm"
                                        v-model="hoursfrom"></datetime>
                            </div>-->
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
              <!--<div v-if="busquedaPorHoras" class="form-group">
                                <label>{{$t("horaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        type="time"
                                        class="theme-numier"
                                        :title="$t('horaFin')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        format="HH:mm"
                                        v-model="hoursto"></datetime>
                            </div>-->
            </div>

            <!--<div class="col-md-2" style="margin-top: 10px">
                            <label> </label><br>
                            <div class="form-group">
                                <el-checkbox
                                        v-model="busquedaPorHoras">
                                    <strong>{{$t("buscarPorHoras")}}</strong>
                                </el-checkbox>

                            </div>

                        </div>-->

            <div class="col-md-3">
              <label>&nbsp;</label>
              <div style="text-align: center" class="form-group">
                <button
                  class="btn btn-primary"
                  @click="tieneSage()"
                >
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="20"
                  />
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <template v-if="listSage && listSage.length > 0">
          <div class="table-responsive">
            <div>
              <template>
                <table
                  class="table table-bordered table-striped tableVentas text-nowrap"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th>
                        {{ $t("fechaDeAperturaDeCaja") }}
                      </th>
                      <th>
                        {{ $t("numeroDeCierres") }}
                      </th>
                      <th>
                        {{ $t("descargarVentas") }}
                      </th>
                      <th>
                        {{ $t("ventasExportadas") }}
                      </th>
                      <th>
                        {{ $t("descargarGastos") }}
                      </th>
                      <th>
                        {{ $t("gastosExportados") }}
                      </th>
                    </tr>
                  </thead>
                  <!-- CUERPO DE LA TABLA -->
                  <tbody>
                    <tr
                      v-for="sage in listSage"
                      class="trDay"
                      :key="sage.Comentario"
                    >
                      <td>{{ sage.fechaInicio | parseDate }}</td>
                      <!--<td v-if="sage.fechaFin != 0">{{ sage.fechaFin | parseDate }}</td>
                      <td v-else>-</td>-->
                      <td>{{ sage.numeroCierre }}</td>
                      <td v-if="sage.numeroCierre > 0"
                        @click="descargarSage(sage.listDays, sage.fechaInicio, false)"
                      ><i
                          style="black"
                          class="fas fa-file-download fa"
                          :title="$t('descargarVentas')"
                        ></i></td>
                      <td v-else>
                        <span>{{ $t("noExistenVentasEsteDia") }}</span>
                      </td>
                      <td v-if="sage.numeroCierre <= 0">
                        
                      </td>
                      <td v-else-if="sage.ventasExportadoSage == 1">
                        <i
                          style="black"
                          class="fas fa-check"
                          :title="$t('todosLosCierresDeEsteDiaHanSidoExportados')"
                        ></i>
                      </td>
                      <td v-else>
                        <i
                          style="black"
                          class="fas fa-times"
                          :title="$t('faltanVentasPorExportarEsteDia')"
                        ></i>
                      </td>
                      <td v-if="sage.numeroGastos"
                        @click="descargarSage(null, sage.fechaInicio, true)"
                      ><i
                          style="black"
                          class="fas fa-file-download fa"
                          :title="$t('descargarGastos')"
                        ></i></td>
                      <td v-else>
                        <span>{{ $t("noExistenGastosEsteDia") }}</span>
                      </td>
                      <td v-if="!sage.numeroGastos">

                      </td>
                      <td v-else-if="sage.gastosExportadoSage == 1">
                        <i
                          style="black"
                          class="fas fa-check"
                          :title="$t('todosLosGastosDeEsteDiaHanSidoExportados')"
                        ></i>
                      </td>
                      <td v-else>
                        <i
                          style="black"
                          class="fas fa-times"
                          :title="$t('faltanGastosPorExportarEsteDia')"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="listSage && listSage.length <= 0 && loading">
          <div class="alert alert-primary" role="alert">
            {{ $t("cargandoAsientosContables") }}
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Datetime from "vue-datetime";
import {
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import download from "downloadjs";

export default {
  //ESTO NO SE SE HA UTILIZADO NUNCA NI SE VA A UTILIZAR, ES DEL PRIMER ACERCAMIENTO A SAGE
  created() {
    this.loading = true;
    this.$store.dispatch("setNameRoute", this.$i18n.t("sageasientos"));
    this.getBusiness();
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),

      hoursfrom: "00:00:00",
      hoursto: "23:59:59",

      loading: false,
      listSage: [],
      listBusinesses: [],
      listTpv: [],
      idsTPV: [],
      listCheckBoxTpv: [],
      idBusiness: 0,
      idTpv: 0,
      busquedaPorHoras: false,
      listDays: null,
      dateFrom: null,
      isGasto: false,
      numAsientoContable: 0,
    };
  },
  computed: {},
  methods: {
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTpv() {
      if (this.idBusiness.length > 0) {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpv = [];
              vm.idTpv = response.data.result[0].id;

              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
              }
              vm.listCheckBoxTpv = response.data.result;

              /*let printer = {
                nameShow: vm.$t("todos"),
                id: 0,
              };
              vm.listTpv.push(printer);*/

              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }

              vm.tieneSage();
              //vm.getSAGEAsientosContables();
              vm.grafica = 0;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    changeTPV() {
      if (this.listCheckBoxTpv && this.idTpv === 0) {
        this.idsTPV = [];
        for (let i = 0; i < this.listCheckBoxTpv.length; i++) {
          this.idsTPV.push(this.listCheckBoxTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }

      this.tieneSage();
    },
    tieneSage() {
      if (this.idBusiness.length > 0) {

        var config = {
          params: {
            idTpv: this.idTpv,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "importacion/getSageBusinessData", config)
          .then(function (response) {
            if(response.data.result.length > 0) {
              vm.getSAGEAsientosContables();
            } else {
              swal({
                title: vm.$t("loSientoSuNegocioNoTieneContratadoSAGE"),
                text: vm.$t("paraMasInformacionContacteConComerciales"),
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
              vm.listSage = [];
            }
          }).catch(function (error) {
            console.log(error);
          });
      }
    },
    descargarSage(listDays, dateFrom, gastos) {

      if(gastos) {
        this.descargarGastosSage(dateFrom);
      } else {
        this.descargarVentasSage(listDays, dateFrom);
      }

    },
    getSAGEAsientosContables() {
      if (this.idBusiness.length > 0) {
        if (this.datefrom === null || this.dateto === null) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.getSAGEAsientosContablesSinHoras();
        }
      }
    },
    getSAGEAsientosContablesSinHoras() {
      let secondsDesde = moment(this.datefrom).startOf("day").unix();
      let secondsHasta = moment(this.dateto).endOf("day").unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        this.loading = true;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
            idTpv: this.idTpv,
            datefrom: secondsDesde,
            dateto: secondsHasta,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "importacion/getAsientosContablesSAGE",
            config
          )
          .then(function (response) {

            vm.listSage = [];

            for(var i = 0; i<response.data.result.length; i++) {

              var insertado = false;

              var humanDate1 = moment.tz(moment.unix(response.data.result[i].initDate), 'Europe/Madrid').format("DD-MM-YYYY");

              for(var j = 0; j<vm.listSage.length; j++) {

                var humanDate2 = moment.tz(moment.unix(vm.listSage[j].fechaInicio), 'Europe/Madrid').format("DD-MM-YYYY");
                
                if(humanDate1 == humanDate2) {
                  vm.listSage[j].listDays.push(response.data.result[i].id);

                  if(vm.listSage[j].ventasExportadoSage == 1 && (response.data.result[i].exportadoSage == 0 || response.data.result[i].exportadoSage == null) ) {
                    vm.listSage[j].ventasExportadoSage = 0;
                  } 

                  if(response.data.result[i].endDate != 0) {
                    vm.listSage[j].numeroCierre++;
                  }

                  insertado = true;
                };

              }

              if(!insertado) {
                if(response.data.result[i].endDate == 0) {
                  vm.listSage.push({fechaInicio: response.data.result[i].initDate, numeroCierre: 0, numeroGastos: 0, 
                  listDays: [response.data.result[i].id], ventasExportadoSage: response.data.result[i].exportadoSage?response.data.result[i].exportadoSage:0,
                  gastosExportadoSage: 0});
                } else {
                  vm.listSage.push({fechaInicio: response.data.result[i].initDate, numeroCierre: 1, numeroGastos: 0, 
                  listDays: [response.data.result[i].id], ventasExportadoSage: response.data.result[i].exportadoSage?response.data.result[i].exportadoSage:0,
                  gastosExportadoSage: 0});
                }
              }

            }

            vm.getGastosAsientosContables();

          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getGastosAsientosContables() {
      let secondsDesde = moment(this.datefrom).startOf("day").unix();
      let secondsHasta = moment(this.dateto).endOf("day").unix();

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idTpv: this.idTpv,
          datefrom: secondsDesde,
          dateto: secondsHasta,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
       this.axios
          .get(
            this.$store.getters.apiUrl + "importacion/getGastosAsientosCotablesSAGE",
            config
          )
          .then(function (response) {

            if(response.data.result) {
              for(var i = 0; i<response.data.result.length; i++) {
                var insertado = false;
                var humanDate1 = moment.tz(moment.unix(response.data.result[i].date), 'Europe/Madrid').format("DD-MM-YYYY");

                for(var j = 0; j<vm.listSage.length; j++) {
                  var humanDate2 = moment.tz(moment.unix(vm.listSage[j].fechaInicio), 'Europe/Madrid').format("DD-MM-YYYY");
                  if(humanDate1 == humanDate2) {

                    if(vm.listSage[j].numeroGastos == 0) {
                      vm.listSage[j].gastosExportadoSage = response.data.result[i].exportadoSage?response.data.result[i].exportadoSage:0;
                    } else {

                      if(vm.listSage[j].gastosExportadoSage == 1 && (response.data.result[i].exportadoSage == 0 || response.data.result[i].exportadoSage == null) ) {
                        vm.listSage[j].gastosExportadoSage = 0;
                      }

                    }

                    vm.listSage[j].numeroGastos++;
                    insertado = true;
                  }
                }
                if(!insertado) {
                  vm.listSage.push({fechaInicio: response.data.result[i].date, numeroCierre: 0, numeroGastos: 1, listDays: [], 
                  ventasExportadoSage: 0, gastosExportadoSage: response.data.result[i].exportadoSage?response.data.result[i].exportadoSage:0});
                  
                  vm.listSage.sort((a, b) => parseFloat(a.fechaInicio) - parseFloat(b.fechaInicio));
                }
              }
            }

            vm.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    descargarVentasSage(listDays, dateFrom) {
      this.$modal.hide("modalAsientoContable");

      let fechaVenta = moment.tz(moment.unix(dateFrom), 'Europe/Madrid').format("DD-MM-YYYY");

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idTpv: this.idTpv,
          listDays: listDays,
          gastos: false,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "importacion/importarSAGEAsientosContables",
          config
        )
        .then(function (response) {
          download(response.data.result, "Ventas_" + fechaVenta + ".txt", "text/plain");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargarGastosSage(dateFrom) {
      this.$modal.hide("modalAsientoContable");

      let secondsDesde = moment(moment.unix(dateFrom)).startOf("day").unix();
      let secondsHasta = moment(moment.unix(dateFrom)).endOf("day").unix();

      let fechaGasto = moment.tz(moment.unix(dateFrom), 'Europe/Madrid').format("DD-MM-YYYY");

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idTpv: this.idTpv,
          datefrom: secondsDesde,
          dateto: secondsHasta,
          gastos: true,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "importacion/importarSAGEAsientosContables",
          config
        )
        .then(function (response) {
          download(response.data.result, "Gastos_" + fechaGasto + ".txt", "text/plain");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.titleModalSage {
  margin: 0px;
  text-align: center;
}
.fa-file-download {
  font-size: 25px;
}

.fa-info-circle {
  color: #2C6CF6;
}

a li {
  color: #111;
}

.card {
  padding: 20px;
}

.trDay:hover {
  background-color: rgba(68, 125, 247, 0.2) !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Sage/AsientoContable.vue